import { render } from "./CreateArticle.vue?vue&type=template&id=b6201b54&scoped=true"
import script from "./CreateArticle.vue?vue&type=script&lang=js"
export * from "./CreateArticle.vue?vue&type=script&lang=js"

import "./CreateArticle.vue?vue&type=style&index=0&id=b6201b54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6201b54"]])

export default __exports__